import axios from "axios";
import API from "../helpers/api";

export const getFlagList = () => {
  let url = `${API.FlagList}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "getflagListSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "getflagListFailure",
          error: "ERROR",
        });
      });
  };
};
export const getClientNameList = (item) => {
  let url = `${API.Clientlist}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "getClientNameListSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "getClientNameListFailure",
          error: "ERROR",
        });
      });
  };
};
export const getApproverNameList = () => {
  let url = `${API.EnrollmentUserlist}?IsApprover=true`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "getApproverNameListSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "getApproverNameListFailure",
          error: "ERROR",
        });
      });
  };
};
export const getCoordinatorNameList = (item) => {
  let url = `${API.EnrollmentUserlist}?IsApprover=false`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "getCoordinatorNameListSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "getCoordinatorNameListFailure",
          error: "ERROR",
        });
      });
  };
};

export const getClientUsersList = (item) => {
  let url = `${API.ClientUserlist}?ClientName=${item}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "getClientUserListSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "getClientUserListFailure",
          error: "ERROR",
        });
      });
  };
};
export const getModelsOtherList = (item) => {
  let url = `${API.GetOthersList}?makeName=${item ??""}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "getModelsOthersListSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "getModelsOthersListFailure",
          error: "ERROR",
        });
      });
  };
};
export const getMakeList = () => {
  let url = `${API.MakesList}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "getMakesListSuccess",
          data: response.data.makes,
        });
      })
      .catch((error) => {
        dispatch({
          type: "getMakesListFailure",
          error: "ERROR",
        });
      });
  };
};
export const getModelsList = (item) => {
  let url = `${API.Modelslist}?makeName=${item ??""}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "getModelsListSuccess",
          data: response.data.models,
        });
      })
      .catch((error) => {
        dispatch({
          type: "getModelsListFailure",
          error: "ERROR",
        });
      });
  };
};

export const getEquipmentNameList = () => {
  let url = `${API.EquipmentName}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "getEquipmentNameListSuccess",
          data: response.data.equipment,
        });
      })
      .catch((error) => {
        dispatch({
          type: "getEquipmentNameListFailure",
          error: "ERROR",
        });
      });
  };
};

export const getEquipmentNameListAndId = () => {
  let url = `${API.EquipmentNameAndId}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
   /*      const uniqueIds = [];
        const unique = response.data.filter((element) => {
          const isDuplicate = uniqueIds.includes(element.name);
          if (!isDuplicate) {
            uniqueIds.push(element.name);
            return true;
          }
          return false;
        }); */

        dispatch({
          type: "getEquipmentNameListAndIdSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "getEquipmentNameListAndIdFailure",
          error: "ERROR",
        });
      });
  };
};

export const getCategoryList = (type) => {
  let url = `${API.lookupNamelist}?type=${type}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "getCategoryListSuccess",
          data: response.data.list,
        });
      })
      .catch((error) => {
        dispatch({
          type: "getCategoryListFailure",
          error: "ERROR",
        });
      });
  };
};
export const getClassList = (type) => {
  let url = `${API.lookupNamelist}?type=${type}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "getClassListSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "getClassListFailure",
          error: "ERROR",
        });
      });
  };
};
export const getEquipmentTypeList = (type) => {
  let url = `${API.lookupNamelist}?type=${type}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "getEquipmentTypeListSuccess",
          data: response.data.list,
        });
        console.log("equipment",response.data)
      })
      .catch((error) => {
        dispatch({
          type: "getEquipmentTypeListFailure",
          error: "ERROR",
        });
      });
  };
};
export const getEquipmentDropDownList = (item) => {
  
  let url = `${API.EquipmentDropDown}?EquipmentName=${encodeURIComponent(item.EquipmentName)}&EquipmentType=${item.EquipmentType}&Category=${encodeURIComponent(item.Category)}&Capacity=${item.Capacity}&MakeId=${item.makeId}&davitWinchMakeId=${item.davitwinchMakeId}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "getEquipmentDropDownListSuccess",
          data: response.data,
        });
        let uniqIds = {}, source = response.data[0].make;
        let filtered = source.filter(obj => !uniqIds[obj.name] && (uniqIds[obj.name] = true));
        console.log(filtered);
        dispatch({
          type: "getMakesListEquipmentSuccess",
          data: filtered,
        });
        dispatch({
          type: "getModelsListEquipmentSuccess",
          data: response.data[0].model,
        });
      })
      .catch((error) => {
        dispatch({
          type: "getEquipmentDropDownListFailure",
          error: "ERROR",
        });
      });
  };
};
export const getShipEquipmentAndCategoryList = (item) => {
  let url = `${API.EquipmentDropDown}?EquipmentName=${item.EquipmentName}&shipId=${item.shipId}&Category=${item.Category}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        let thing = response.data.filter(
          (thing, index, self) =>
            index ===
            self.findIndex(
              (t) =>
                t.category === thing.category &&
                t.category !== null &&
                thing.category !== null
            )
        );
        thing.sort(function (a, b) {
          var textA = a.category.toUpperCase();
          var textB = b.category.toUpperCase();
          return textA < textB ? -1 : textA > textB ? 1 : 0;
        });
        let thing1 = response.data.filter(
          (thing, index, self) =>
            index ===
            self.findIndex(
              (t) =>
                t.equipmentName === thing.equipmentName &&
                t.equipmentName !== null &&
                thing.equipmentName !== null
            )
        );
        thing1.sort(function (a, b) {
          var textA = a.equipmentName.toUpperCase();
          var textB = b.equipmentName.toUpperCase();
          return textA < textB ? -1 : textA > textB ? 1 : 0;
        });
        dispatch({
          type: "getEquipmentNameList",
          data: thing1,
        });
        dispatch({
          type: "getCategoryNameList",
          data: thing,
        });
      })

      .catch((error) => {
        dispatch({
          type: "getEquipmentDropDownListFailure",
          error: "ERROR",
        });
      });
  };
};
export const getPortNameList = () => {
  let url = `${API.portList}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "getPortNameListSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "getPortNameListFailure",
          error: "ERROR",
        });
      });
  };
};
export const getApplicableServiceTypeList = (equipment) => {
  let url = `${API.ServiceType}?EquipmentName=${equipment}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "getServiceTypeListSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "getServiceTypeListFailure",
          error: "ERROR",
        });
      });
  };
};

export const getApplicableServiceTypeBudgetList = () => {
  let url = `${API.ServiceType}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "getServiceTypeBudgetListSuccess",
          data: response.data,
        });
  
      })
      .catch((error) => {
        dispatch({
          type: "getServiceTypeBudgetListFailure",
          error: "ERROR",
        });
      });
  };
};

export const getApplicableServiceTypeListWithInterval = (equipmentId,shipId,makeId,modelId) => {
  let url = `${API.ServiceTypeInterval}?shipid=${shipId}&equipmentId=${equipmentId}&makeId=${makeId}&modelId=${modelId}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        // if (response.data) {
        //     response.data.map((f, index) => {
        //         let interval = f.interval;
        // dispatch(getServiceDates('', interval))
        //         dispatch({
        //             type: "getServiceDatelistSuccess",
        //             data: interval,
        //         })
        //     })
        // }
        dispatch({
          type: "getServiceTypeIntervalListSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "getServiceTypeIntervalListFailure",
          error: "ERROR",
        });
      });
  };
};

export const getEquipmentServiceTypeListWithInterval = (equipmentId,shipId,makeId,modelId,davitwinchMakeId) => {
  let url = `${API.EquipmentServiceIntervalList}?shipid=${shipId}&equipmentId=${equipmentId}&makeId=${makeId??0}&modelId=${modelId??0}&davitWinchMakeId=${davitwinchMakeId??0}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        // if (response.data) {
        //     response.data.map((f, index) => {
        //         let interval = f.interval;
        // dispatch(getServiceDates('', interval))
        //         dispatch({
        //             type: "getServiceDatelistSuccess",
        //             data: interval,
        //         })
        //     })
        // }
        dispatch({
          type: "getServiceTypeIntervalListSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "getServiceTypeIntervalListFailure",
          error: "ERROR",
        });
      });
  };
};

export const getServiceDates = (serviceType, interval, type) => {
  let url = `${API.ServiceDue}?ServiceDate=${serviceType}&interval=${interval}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        if (type) {
          response.data.serviceType = type;
        }

        dispatch({
          type: "getServiceDateSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "getServiceDateFailure",
          error: "ERROR",
        });
      });
  };
};

export const getTypeofShipList = (type) => {
  let url = `${API.lookupNamelist}?type=${type}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "getTypeofShipListSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "getTypeofShipListFailure",
          error: "ERROR",
        });
      });
  };
};
export const getMiscTypeList = () => {
   let url = `${API.getMisctypeDropdownList}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "getMiscTypeListListSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "getMiscTypeListListFailure",
          error: "ERROR",
        });
      });
  };
};
export const getApplicableSeviceTypewithIdList = () => {
let Url=`${API.GetServiceTypeList}`;
return (dispatch) => {
  axios
    .get(Url)
    .then((res) => {
   let list = [];
  let serviceTypeList = [];
  res.data.map((item, index) => {
    let listItem = item.serviceTypes.split(" ");
    let order = (listItem[0]);
    let id = item.id;
    list.push({
      id,
      order,
    });
  });

  let mainList = list.sort(function (a, b) {
    return a.order - b.order;
  });
  mainList.map((item, i) => {
    let serviceTypes = item.order + " yearly";
    item = item.id;
    serviceTypeList.push({
      item,
      serviceTypes,
    });
  });
  dispatch({
    type: "getApplicableSeviceTypewithIdListSuccess",
    data: serviceTypeList,
  });
})
.catch((error) => {
  dispatch({
    type: "getApplicableSeviceTypewithIdListFailure",
    error: "ERROR",
  });
});
}
}
 

